import type { InternetOffersApiResponse, InternetOfferResponse, Offer } from '@/types/offers';

export const mapApiResponseToOffers = (apiResponse: InternetOffersApiResponse): Offer[] => {
  return apiResponse.Data.Offers.map(mapOfferResponseToOffer);
};

export const mapOfferResponseToOffer = (offerResponse: InternetOfferResponse): Offer => {
  const { OfferId, PriceInfo, Content } = offerResponse;

  const speedNum = parseInt(Content.Mbps || '0');
  const unit = speedNum >= 1000 ? 'gig' : 'mbps';
  const displaySpeedNum = speedNum >= 1000 ? speedNum / 1000 : speedNum;
  const speed = displaySpeedNum.toString();

  const features = extractFeatures(Content);

  return {
    offerId: OfferId,
    speed,
    unit,
    badge: Content.INTERNET_TIER || Content.Name || `${speed} ${unit.toUpperCase()}`,
    features,
    pricing: PriceInfo,
    metadata: Content,
    isBestValue: Content.highlightEyebrow === 'Recommended' || Content.Level2 === 'Recommended',
  };
};

const extractFeatures = (content: Record<string, unknown>): string[] => {
  const features: string[] = [];

  if (typeof content.InternetHighlight1 === 'string') features.push(content.InternetHighlight1);
  if (typeof content.InternetHighlight2 === 'string') features.push(content.InternetHighlight2);
  if (typeof content.InternetHighlight3 === 'string') features.push(content.InternetHighlight3);
  if (typeof content.InternetHighlight4 === 'string') features.push(content.InternetHighlight4);

  if (typeof content.offerHighlight8_SubSplit === 'string') features.push(content.offerHighlight8_SubSplit);
  else if (typeof content.offerHighlight8_MidSplit === 'string') features.push(content.offerHighlight8_MidSplit);
  else if (typeof content.offerHighlight8_EPON === 'string') features.push(content.offerHighlight8_EPON);
  else if (typeof content.offerHighlight8_FDX === 'string') features.push(content.offerHighlight8_FDX);

  return features.filter(Boolean);
};